import "./confirm-dialog.scoped.scss";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { ConfirmDialogProps } from "../../types/confirm-dialog-props";
import { useTranslation } from "react-i18next";
import CheckIcon from "@material-ui/icons/Check";
import AppButtonComponent from "../../components/form/app-button";
import { Box, Typography } from "@material-ui/core";

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const handleClose = (value: any) => props.onClose(value);
  const { t } = useTranslation();

  return (
    <Modal
      show={props.show}
      onHide={handleClose.bind(null, false)}
      centered
      dialogClassName={
        props.dialogClassName ? props.dialogClassName : "modal-md"
      }
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Typography
            variant="h3"
            color="textPrimary"
            className="font-weight-bold"
          >
            {props.dialogTitle}
          </Typography>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Typography variant="body1" color="textPrimary">
          {props.dialogBody}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {props.dialogExtraText}
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
          {props.cancelBtn && (
            <AppButtonComponent
              variant="text"
              color="secondary"
              size="large"
              onClick={handleClose.bind(null, false)}
            >
              {t("CANCEL")}
            </AppButtonComponent>
          )}
          <AppButtonComponent
            onClick={handleClose.bind(null, true)}
            variant="contained"
            size="large"
            color="primary"
          >
            {props.showCheck ? <CheckIcon /> : null} {t(props.confirmBtnText)}
          </AppButtonComponent>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};
